<template>
  <section class="car-class-list-container">
    <div class="header">
      <div class="filter mg-b-5">
        <div class="statis-tip">
          <span  class="inline-block"><span class="fs-24">{{modelNum}}</span>  Models</span>
        </div>
        <div class="flex">
          <!--          <div class="item">-->
          <!--            <span class="item_name">Make</span>-->
          <!--            <v-select-->
          <!--              v-model="filter.make_id"-->
          <!--              :list="carClassMakeList"-->
          <!--              @change="filterData"-->
          <!--            ></v-select>-->
          <!--          </div>-->
          <div class="item">
            <span class="item_name">Model</span>
            <v-input
              v-model="filter.model"
              keyNonChinese
              uppercase
              :prefixIcon="'el-icon-search'"
              @change="filterData"></v-input>
          </div>
        </div>
      </div>
      <div class="filter mg-t-15">
        <div
          class="form-item flex-sb-center"
          :class="{'pd-b-0':!showFilterCard}">
          <span
            class="item_name"
          >Add Make</span>
          <span>
            <font-awesome-icon
              v-if="showFilterCard"
              icon="square-minus"
              class="icon pointer"
              @click="showFilterCard=false"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else
              icon="square-plus"
              class="icon pointer"
              @click="showFilterCard=true"
            ></font-awesome-icon>
          </span>
        </div>
        <template v-if="showFilterCard">
          <el-form
            ref="add-form"
            :model="addFormData"
            :rules="rules">
            <div
              v-for="(item,index) in addFormData.list"
              :key="'add'+index"
              class="flex flex-align-center add-content">
              <div

                class="flex mg-b-15">
                <div class="item">
                  <span class="item_name">Make</span>
                  <el-form-item
                    :ref="`list.${index}.make_id`"
                    :rules="rules.select"
                    :prop="`list.${index}.make_id`">
                    <v-select
                      v-model="item.make_id"
                      :list="makeList"
                      disabled
                    ></v-select>
                  </el-form-item>
                </div>
                <div class="item">
                  <span class="item_name">Model</span>
                  <el-form-item
                    :ref="`list.${index}.model`"
                    :rules="rules.input"
                    :prop="`list.${index}.model`">
                    <v-input
                      v-model="item.model"
                      keyNonChinese
                      uppercase
                    ></v-input>
                  </el-form-item>
                </div>
                <div class="item">
                  <span class="item_name">EV</span>
                  <el-form-item
                    :ref="`list.${index}.grade_electric`"
                    :rules="rules.select"
                    :prop="`list.${index}.grade_electric`">
                    <v-select
                      v-model="item.grade_electric"
                      :list="carClassOption.ev"
                    ></v-select>
                  </el-form-item>
                </div>
                <div class="item">
                  <span class="item_name">Windscreen</span>
                  <el-form-item
                    :ref="`list.${index}.grade_wind`"
                    :rules="rules.select"
                    :prop="`list.${index}.grade_wind`">
                    <v-select
                      v-model="item.grade_wind"
                      :list="carClassOption.windscreen"
                    ></v-select>
                  </el-form-item>
                </div>
                <div class="item">
                  <span class="item_name">Status</span>
                  <el-form-item
                    :ref="`list.${index}.status`"
                    :rules="rules.select"
                    :prop="`list.${index}.status`">
                    <v-select
                      v-model="item.status"
                      :list="makeStatusOptions"
                    ></v-select>
                  </el-form-item>
                </div>
              </div>
              <span class="icon flex-align-center">
                <span
                  class="blue pointer mg-r-15"
                  @click="handleClear(index)">Clear</span>
                <span
                  v-show="index!=0"
                  class="el-icon-close pointer "
                  @click="handleDel(index)"></span>
              </span>
            </div>
          </el-form>
          <div class="flex-sb-center  mg-t-15">
            <v-button
              gray
              icon="plus"
              @click="handleAddMake">Add New Model</v-button>
            <v-button
              green
              @click="handleConfirm">Confirm</v-button>
          </div>
        </template>
      </div>
    </div>
    <div class="main">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <el-table
          :data="formData.list"
          style="width: 100%"
          :header-row-class-name="'tableHeader'"
        >
          <el-table-column
            width="10px"
            align="center">
            <template #default="{ row }">
              <span></span>
            </template>
          </el-table-column>
          <el-table-column
            width="275px"
            label="Make">
            <template #default="{ row }">
              <!--              <div class="flex-column time">-->
              <!--                <v-select-->
              <!--                  v-model="row.make_id"-->
              <!--                  :list="carClassOption.make"></v-select>-->
              <!--              </div>-->
              <span>{{getOptionName('carClassOption.make',row.make_id)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="275px"
            label="Model">
            <template  slot-scope="scope">
              <!--              <el-form-item-->
              <!--                :ref="`list.${scope.$index}.model`"-->
              <!--                :rules="rules.input"-->
              <!--                :prop="`list.${scope.$index}.model`"-->
              <!--              >-->
              <!--                <v-input-->
              <!--                  v-model="scope.row.model"-->
              <!--                  keyNonChinese-->
              <!--                  uppercase></v-input>-->
              <!--              </el-form-item>-->
              <span>{{scope.row.model}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="EV">
            <template #default="{ row }">
              <!--              <v-select-->
              <!--                v-model="row.grade_electric"-->
              <!--                :list="carClassOption.ev"-->
              <!--              ></v-select>-->
              <span>{{getOptionName('carClassOption.ev',row.grade_electric)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Windscreen">
            <template #default="{ row }">
              <!--              <v-select-->
              <!--                v-model="row.grade_wind"-->
              <!--                :list="carClassOption.windscreen"-->
              <!--              ></v-select>-->
              <span>{{getOptionName('carClassOption.windscreen',row.grade_wind)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Status">
            <template #default="{ row }">
              <!--              <v-select-->
              <!--                v-model="row.status"-->
              <!--                :list="carClassOption.status"-->
              <!--              ></v-select>-->
              <span :class="[row.status==1?'green':'red']">{{getOptionName('makeStatusOptions',row.status)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Action">
            <template #default="{ row }">
              <div class="flex">
                <span
                  class="blue pointer block mg-r-15"
                  @click="handleEdit(row)">Edit</span>
                <span
                  class="blue pointer block mg-r-15"
                  @click="handleGrade(row)">Grade</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
    <edit-manage-model-dialog
      v-model="showEdit"
      :class-id="classId"
      :form="rowData"
      @refresh="filterData"></edit-manage-model-dialog>
    <edit-grade-dialog
      v-model="showGrade"
      :class-id="classId"
      :form="rowGradeData"
      @refresh="filterData"></edit-grade-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {updateCarModel, addCarModel,getCarModelList} from '@/api/privateCarList'
import {mapActions, mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
import EditManageModelDialog from './components/edit-manage-model-dialog'
import EditGradeDialog from './components/edit-grade-dialog'
export default {
  name: 'manage-model',
  components:{
    EditManageModelDialog,
    EditGradeDialog
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    classId:{
      type:Number,
      default:11
    }
  },
  data () {
    return {
      showEdit:false,
      showGrade:false,
      rowData:{},
      rowGradeData:{},
      showFilterCard:false,
      filter: {
        insurer:'',
        make_id:'',
        model:''
      },
      pageConfig: {
        currentPage: 1,
        total: 20,
        per_page:20
      },
      classNum:0,
      makeNum:0,
      modelNum:0,
      addMakeObj:{
        make_id:null,
        model:null,
        grade_wind:null,
        grade_electric:null,
        status:null
      },
      addFormData:{
        list:[
          {
            make_id:null,
            model:null,
            grade_wind:null,
            grade_electric:null,
            status:null
          }]
      },
      formData:{
        list:[]
      }
    }
  },
  computed:{
    makeId(){
      let {make} = this.$route.params||{}
      return make
    },
    makeList(){
      let {make=[]} = this.carClassOption||{}
      return make.filter(item=>item.id==this.makeId)
    }
  },
  watch:{
    makeId:{
      immediate:true,
      handler(val){
        if(val){
          this.addFormData.list.filter(item=>{
            item.make_id =val
          })
          this.addMakeObj.make_id = val
        }
      }
    }
  },
  async mounted(){
    await this.updateCarClassOptions()
    this.filter.make_id = this.makeId
    this.getList()
  },
  methods: {
    ...mapActions('common', ['updateCarClassOptions']),
    handleEdit(data){
      this.rowData = data
      this.showEdit = true
    },
    handleGrade(data){
      this.rowGradeData = data
      this.showGrade = true
    },
    handleDel(index){
      this.addFormData.list.splice(index,1)
    },
    handleClear(index){
      this.addFormData.list[index]={
        make_id:this.makeId,
        model:null,
        grade_wind:null,
        grade_electric:null,
        status:null
      }
      let obj = JSON.parse(JSON.stringify(this.addFormData.list))
      this.addFormData.list =obj
      setTimeout(()=>{
        // this.$refs['add-form'].clearValidate()
        this.$refs['add-form'].clearValidate([`list.${index}.grade_electric`,`list.${index}.status`,`list.${index}.model`,`list.${index}.grade_wind`])
      },50)
    },
    handleAddMake(){
      let obj = JSON.parse(JSON.stringify(this.addMakeObj))
      this.addFormData.list.push(obj)
    },

    handleConfirm(){
      this.$refs['add-form'].validate((valid,rules) => {
        if(valid){
          this.network().addCarModel()
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handleUpdate(){
      this.$refs['form'].validate((valid,rules) => {
        if(valid){
          this.network().updateCarModel()
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.getList()
    },
    handleExport(){
      this.is_export = 1
      this.getList()
    },
    getList(){
      let params = {
        ...this.filter,
        pager: this.pageConfig.currentPage,
        per_page: this.pageConfig.per_page,
      }
      this.network().getCarModelList(params)
    },
    network(){
      return {
        getCarModelList: async(params) =>{
          params = {
            ...params,
            ...this.filter,
            class_id:this.classId
          }
          const {data} = await getCarModelList(params)
          this.formData.list = data.data
          this.modelNum = data.model_count
          this.pageConfig.total = data.model_count
        },
        addCarModel: async(params) =>{
          params = {
            ...this.addFormData,
            class_id:this.classId
          }
          const {data} = await addCarModel(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
          this.addFormData.list = [this.addMakeObj]
          setTimeout(()=>{
            this.$refs['add-form'].clearValidate()
          },50)
          this.network().getCarModelList({hideLoading:true})
        },
        updateCarModel: async(params) =>{
          let {list} = this.formData||{}
          params = {
            list,
            class_id:this.classId
          }
          const {data} = await updateCarModel(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../assets/css/car-class-list';
.add-content{
  .item{
    max-width: 220px;
    width: 100% !important;
  }
  .icon{
    width: 80px;
    margin-left: 15px;
    .el-icon-close{
      font-size: 14px;
      font-style: normal;
      font-weight: 900;
      line-height: 16px;
      color: #6A737D;
      width: 20px;
    }
  }
}
</style>
